import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  FieldWrapper,
  Label,
  SubmitBtn,
  CombineInputGroup,
} from "../Styles/InputStyles";
import Loading from "../Loading";
import MenuItem from "@mui/material/MenuItem";
//import Select from "react-select";
import Select from "@mui/material/Select";

import Model from "../Model";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import CustomPhoneInput from "../CountryCode";
const AddModel = ({

  postAddUser,
  setOpenUploadModel,
  AddUserLoading,

  data,
  // companyArr,
}) => {
  const [uploadFile, setUploadFile] = useState("");
  const [districtsList, setDistricts] = useState([]);
  const [error, setError] = useState('');
  const { t, i18n } = useTranslation();
  const InitialValues = {

  };
  //console.log(data)
  const SubmitHandler = (values) => {
    //console.log(values);
    postAddUser(values);
  };

  const Roles = [
    // { value: "1", label: "Admin" },
    { value: "1", label: "Add" },
    { value: "2", label: "Modify" },
    { value: "3", label: "Both" }

    // { value: "Administrator", label: "Administrator" },
  ];
  // const Company=data?.map((item)=>({
  //   value:item.id,
  //   label:item.name,
  // }))

  return (
    <Model width={`w-11/12 max-w-xl `} setOpenModel={setOpenUploadModel}>
      <Title>Add Field Agent</Title>

      {AddUserLoading && <Loading />}

      {!AddUserLoading && (
        <Formik initialValues={InitialValues} onSubmit={SubmitHandler}>
          <Form>
            <Wrapper>
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="fName" >First Name</Label>
                  <FieldWrapper>
                    <Field name="fName" id="fName" autoComplete="off" type="text" required />
                  </FieldWrapper>
                </InputGroup>
                <InputGroup>
                  <Label htmlFor="lName">Last Name</Label>
                  <FieldWrapper>
                    <Field name="lName" id="lName" autoComplete="off" type="text" required />
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="email">Email</Label>
                  <FieldWrapper>
                    <Field
                      type="email"
                      name="email"
                      id="email"
                      autoComplete="off"
                      className="truncate"
                    // required
                    />
                  </FieldWrapper>
                </InputGroup>

                <InputGroup>
                  <Label htmlFor="phone">Phone Number</Label>
                  <Field
                    name="phone"
                    render={({ field, form }) => (
                      <CustomPhoneInput field={field} form={form} />
                    )}
                  />
                  {/* <FieldWrapper>
                    <Field
                      type="number"

                      maxlength={9}
                      name="phone"
                      id="phone"
                      autoComplete="off"
                      className="truncate"
                      required

                    />
                  </FieldWrapper> */}
                </InputGroup>
              </CombineInputGroup>


              <InputGroup>
                <Label htmlFor="password">Password</Label>
                <FieldWrapper>
                  <Field
                    type="password"
                    name="password"
                    id="password"
                    autoComplete="off"
                    className="truncate"
                    required
                  />
                </FieldWrapper>
              </InputGroup>
              {/* <InputGroup>
                <Label htmlFor="roles">Roles</Label>
                <FieldWrapper $select={true}>
                  <Field required name="roles" id="roles" autoComplete="off">
                    {(props) => (
                      <Select
                        className="w-full h-full pl-2"
                        options={Roles}
                      />
                    )}
                  </Field>
                </FieldWrapper>
              </InputGroup> */}

              <InputGroup>
                <Label htmlFor="role">Role</Label>
                <FieldWrapper $select={true}>
                  <Field required name="role" id="role" autoComplete="off">
                    {(props) => (
                      <Select
                        className="w-full h-full pl-2"
                        {...props.field}
                      >
                        <MenuItem value="1">Add</MenuItem>
                        <MenuItem value="2">Edit</MenuItem>
                        <MenuItem value="3">Both</MenuItem>
                      </Select>
                    )}
                  </Field>
                </FieldWrapper>
              </InputGroup>

            </Wrapper>
            <BtnWrapper>
              <SubmitBtn type="submit">Add</SubmitBtn>
            </BtnWrapper>
          </Form>
        </Formik>
      )}
    </Model>
  );
};

const Wrapper = tw.div`
grid  gap-6 my-6 px-1`;


const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const BtnWrapper = tw.div`flex justify-center items-center mt-8`;
const ErrorMessage = tw.div`text-xs text-red-500 flex justify-end`;

export default AddModel;
